document.addEventListener('DOMContentLoaded', () => {
  const menuButton = document.querySelector('[data-menu-toggle]');
  const navigation = document.querySelector('[data-nav]');
  const dropdowns = document.querySelectorAll('[data-nav-dropdown]');

  if (menuButton && navigation) {
    menuButton.addEventListener('click', () => {
      const isOpen = navigation.classList.toggle('is-open');
      menuButton.setAttribute('aria-expanded', String(isOpen));
    });
  }

  dropdowns.forEach((dropdown) => {
    dropdown.addEventListener('mouseenter', () => {
      if (window.matchMedia('(min-width: 801px)').matches) dropdown.open = true;
    });

    dropdown.addEventListener('mouseleave', () => {
      if (window.matchMedia('(min-width: 801px)').matches) dropdown.open = false;
    });
  });

  document.addEventListener('click', (event) => {
    dropdowns.forEach((dropdown) => {
      if (!dropdown.contains(event.target)) dropdown.open = false;
    });
  });

  document.querySelectorAll('[data-product-gallery]').forEach((gallery) => {
    const slides = gallery.querySelectorAll('[data-gallery-slide]');
    const thumbnails = gallery.querySelectorAll('[data-gallery-target]');

    thumbnails.forEach((thumbnail) => {
      thumbnail.addEventListener('click', () => {
        const target = thumbnail.dataset.galleryTarget;

        slides.forEach((slide) => {
          const isActive = slide.dataset.gallerySlide === target;
          slide.hidden = !isActive;
          slide.classList.toggle('is-active', isActive);
        });

        thumbnails.forEach((item) => {
          const isActive = item === thumbnail;
          item.classList.toggle('is-active', isActive);
          item.setAttribute('aria-current', String(isActive));
        });
      });
    });
  });
});
